import { call, put, takeLatest, all } from 'redux-saga/effects';
import config from 'config';
import * as actionTypes from '../actionTypes/myAccount';
import { GET_USER_SUCCESS } from '../actionTypes/common';
import apiClient from '../helpers/apiClient';
// import getSetCookie from '../cookie';
let _client = null;
let xApiClient = 'desktop';
// conditional imports on compilation
'#if CLIENT_TYPE === "mobile"'; // eslint-disable-line
xApiClient = 'mobilesite';
'#endif'; // eslint-disable-line

function modifiedOrderResponse(orders, orderStatus) {
    const modifiredorders = [];
    for (let i = 0; i < orders.length; i++) {
        const order = orders[i];
        const oS = order.status;
        const cancellableStatus = oS.cancellableStatus ? oS.cancellableStatus : '';
        const returnableStatus = oS.returnableStatus ? oS.returnableStatus : '';
        const ks = orderStatus[oS.trackingStatus];
        const l = { return_button: null, cancel_button: null, msg: null, status: null, buttons: { a: null, b: null, c: null, d: null, e: null, f: null, g: null } };
        order.ui = l;
        if (ks) {
            for (let k = 0; k < ks.length; k++) {
                if ((ks[k].order_cancellable_status === cancellableStatus) && (ks[k].order_return_status === returnableStatus)) {
                    const fx = { return_button: ks[k].return_button, cancel_button: ks[k].cancel_button, msg: ks[k].msg, status: ks[k].status, buttons: { a: ks[k].buttons.a, b: ks[k].buttons.b, c: ks[k].buttons.c, d: ks[k].buttons.d, e: ks[k].buttons.e, f: ks[k].buttons.f, g: ks[k].buttons.g } };
                    order.ui = fx;
                }
            }
        }
        modifiredorders.push(order);
    }
    return modifiredorders;
}

function makeCall(pageName, size) {
    const client = { ..._client };
    client.setHeader();
    const url = `${config.apiPath.getOrdersList}?page=${pageName}&page-size=${size}`;
    if (xApiClient === 'mobilesite') {
        const statusUrl = config.msiteGlobals.orderStatusApiUrl + '?v=' + new Date().getTime();
        return Promise.all([client.get(url), client.get(statusUrl)]);
    }
    return client.get(url);
}

function* getOrders({ pageName, size }) {
    const successAction = { type: actionTypes.ORDER_LIST_SUCCESS };
    const errorAction = { type: actionTypes.ORDER_LIST_FAIL };
    try {
        const data = yield call(async () => makeCall(pageName, size));
        if (xApiClient === 'mobilesite') {
            modifiedOrderResponse(data[0].result, data[1].result);
            successAction.data = data[0];
        } else {
            successAction.data = data;
        }
        yield put(successAction);
    } catch (er) {
        errorAction.error = er;
        yield put(errorAction);
    }
}

function* updateInfo({ firstName, lastName, gender, email }) {
    const successAction = { type: actionTypes.UPDATE_USER_INFO_SUCCESS };
    const userSuccessAction = { type: GET_USER_SUCCESS };
    const errorAction = { type: actionTypes.UPDATE_USER_INFO_FAIL };
    const client = { ..._client };
    client.setHeader();
    try {
        const data = yield call(async () => client.post(`${config.apiPath.getUserInfo}`, { firstName, lastName, gender, email }));
        successAction.data = data;
        userSuccessAction.data = data;
        userSuccessAction.data.result.login = true;
        yield put(userSuccessAction);
        yield put(successAction);
    } catch (er) {
        errorAction.error = er;
        yield put(errorAction);
    }
}

function* resetPassword({ oldPassword, newPassword, email, token }) {
    const successAction = { type: actionTypes.RESET_PASSWORD_SUCCESS };
    const errorAction = { type: actionTypes.RESET_PASSWORD_FAIL };
    const client = { ..._client };
    client.setHeader();
    let url = `${config.apiPath.changePassword}`;
    let apiData = {};
    if (token) {
        url = `${config.apiPath.resetPassword}/${token}`;
        apiData = { newPassword, confirmNewPassword: newPassword };
    } else {
        apiData = { oldPassword, newPassword, email };
    }
    try {
        const data = yield call(async () => client.post(url, apiData));
        successAction.data = data;
        yield put(successAction);
    } catch (er) {
        errorAction.error = er;
        yield put(errorAction);
    }
}

function* checkVoucher({ voucherCode }) {
    const successAction = { type: actionTypes.CHECK_VOUCHER_SUCCESS };
    const errorAction = { type: actionTypes.CHECK_VOUCHER_FAIL };
    const client = { ..._client };
    client.setHeader();
    try {
        const data = yield call(async () => client.get(`${config.apiPath.giftVoucherBalance}${voucherCode}`));
        successAction.data = data;
        yield put(successAction);
    } catch (er) {
        errorAction.error = er;
        yield put(errorAction);
    }
}

function* storeCredit({ voucherCode }) {
    const successAction = { type: actionTypes.STORE_CREDIT_BAL_SUCCESS };
    const errorAction = { type: actionTypes.STORE_CREDIT_BAL_FAIL };
    const client = { ..._client };
    client.setHeader();
    try {
        const data = yield call(async () => client.get(`${config.apiPath.storeCredit}${voucherCode}`));
        successAction.data = data;
        yield put(successAction);
    } catch (er) {
        errorAction.error = er;
        yield put(errorAction);
    }
}
function* getStoreCreditOrders({ pageName, size }) {
    const successAction = { type: actionTypes.STORE_CREDIT_ORDERS_SUCCESS };
    const errorAction = { type: actionTypes.STORE_CREDIT_ORDERS_FAIL };
    const client = { ..._client };
    client.setHeader();
    try {
        const data = yield call(async () => client.get(`${config.apiPath.storeCredit}orders?page=${pageName}&pagesize${size}`));
        successAction.data = data;
        yield put(successAction);
    } catch (er) {
        errorAction.error = er;
        yield put(errorAction);
    }
}
function* getStoreCreditOrderHistory({ orderId }) {
    const successAction = { type: actionTypes.STORE_CREDIT_ORDER_HISTORY_SUCCESS };
    const errorAction = { type: actionTypes.STORE_CREDIT_ORDER_HISTORY_FAIL };
    const client = { ..._client };
    client.setHeader();
    try {
        const data = yield call(async () => client.get(`${config.apiPath.storeCredit}history?orderId=${orderId}`));
        successAction.data = data;
        yield put(successAction);
    } catch (er) {
        errorAction.error = er;
        yield put(errorAction);
    }
}
function* sendStoreCreditSMS({ orderId }) {
    const successAction = { type: actionTypes.STORE_CREDIT_ORDER_SMS_SUCCESS };
    const errorAction = { type: actionTypes.STORE_CREDIT_ORDER_SMS_FAIL };
    const client = { ..._client };
    client.setHeader();
    try {
        const data = yield call(async () => client.get(`${config.apiPath.storeCredit}sms?orderId=${orderId}`));
        successAction.data = data;
        yield put(successAction);
    } catch (er) {
        errorAction.error = er;
        yield put(errorAction);
    }
}
function* saveNeftValues({ values }) {
    const successAction = { type: actionTypes.EDIT_NEFT_SUCCESS };
    const errorAction = { type: actionTypes.EDIT_NEFT_FAIL };
    const client = { ..._client };
    client.setHeader();
    try {
        const data = yield call(async () => client.post(`${config.apiPath.editNeft}`, values));
        successAction.data = data;
        yield put(successAction);
    } catch (er) {
        errorAction.error = er;
        yield put(errorAction);
    }
}
function* getOrderStatusConfig() {
    const successAction = { type: actionTypes.ORDER_STATUS_CONFIG_SUCCESS };
    const errorAction = { type: actionTypes.ORDER_STATUS_CONFIG_FAIL };
    const client = { ..._client };
    client.setHeader();
    try {
        const data = yield call(async () => client.get(`${config.apiPath.orderStatusConfig}`));
        successAction.data = data;
        yield put(successAction);
    } catch (er) {
        errorAction.error = er;
        yield put(errorAction);
    }
}
function* getOTPForTrackOrder({ phone }) {
    const successAction = { type: actionTypes.TRACK_ORDER_OTP_SUCCESS };
    const errorAction = { type: actionTypes.TRACK_ORDER_OTP_FAIL };
    const client = { ..._client };
    client.setHeader();
    try {
        const data = yield call(async () => client.post(`${config.apiPath.generateOtp}`, { mobile: phone, otpType: 'order', otpDigits: 6 }));
        successAction.data = data;
        yield put(successAction);
    } catch (er) {
        errorAction.error = er;
        yield put(errorAction);
    }
}
function* getGuestOrders({ phone, otp }) {
    const successAction = { type: actionTypes.GUEST_ORDERS_SUCCESS };
    const errorAction = { type: actionTypes.GUEST_ORDERS_FAIL };
    const client = { ..._client };
    client.setHeader();
    const options = {
        headers: {
            phone,
            otp
        }
    };
    try {
        const data = yield call(async () => client.get(`${config.apiPath.guestOrders}?page=0&page-size=1`, options));
        successAction.data = data;
        yield put(successAction);
    } catch (er) {
        errorAction.error = er;
        yield put(errorAction);
    }
}
function* getReturnConfig() {
    const successAction = { type: actionTypes.RETURN_ORDER_CONFIG_SUCCESS };
    const errorAction = { type: actionTypes.RETURN_ORDER_CONFIG_FAIL };
    const client = { ..._client };
    client.setHeader();
    try {
        const data = yield call(async () => client.get(`${config.apiPath.returnConfig}`));
        successAction.data = data;
        yield put(successAction);
    } catch (er) {
        errorAction.error = er;
        yield put(errorAction);
    }
}

export function* runMyAccountCalls(client) {
    _client = client ? Object.assign({}, client) : apiClient();
    yield all([
        takeLatest(actionTypes.ORDER_LIST_LOAD, getOrders),
        takeLatest(actionTypes.UPDATE_USER_INFO_LOAD, updateInfo),
        takeLatest(actionTypes.RESET_PASSWORD_LOAD, resetPassword),
        takeLatest(actionTypes.CHECK_VOUCHER_LOAD, checkVoucher),
        takeLatest(actionTypes.STORE_CREDIT_BAL_LOAD, storeCredit),
        takeLatest(actionTypes.STORE_CREDIT_ORDERS_LOAD, getStoreCreditOrders),
        takeLatest(actionTypes.STORE_CREDIT_ORDER_HISTORY_LOAD, getStoreCreditOrderHistory),
        takeLatest(actionTypes.STORE_CREDIT_ORDER_SMS_LOAD, sendStoreCreditSMS),
        takeLatest(actionTypes.EDIT_NEFT_LOAD, saveNeftValues),
        takeLatest(actionTypes.ORDER_STATUS_CONFIG_LOAD, getOrderStatusConfig),
        takeLatest(actionTypes.TRACK_ORDER_OTP_LOAD, getOTPForTrackOrder),
        takeLatest(actionTypes.GUEST_ORDERS_LOAD, getGuestOrders),
        takeLatest(actionTypes.ORDER_LIST_LOAD_MORE, getOrders),
        takeLatest(actionTypes.RETURN_ORDER_CONFIG_LOAD, getReturnConfig)
    ]);
}
